/**
 * Trigger some modals that could show up on any page.
 */
export default function () {
    // Disabled for now
    // window.onNuxtReady(() => {})
}
